import { KeyframeConfig } from "../../../models/animations.model";

const SUNNY_MORNINGS_SCALE = 4;

export const getSunnyMorningsBaseKeyframe = (
  letterObjects: fabric.Object[],
  scaleX: number,
  scaleY: number,
  opacity: number,
  delay: number,
  duration: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            scaleX: SUNNY_MORNINGS_SCALE,
            scaleY: SUNNY_MORNINGS_SCALE,
            duration: 1,
            opacity: 0,
          },
          {
            scaleX,
            scaleY,
            duration,
            opacity,
          },
        ],
        targets: letterObjects,
        delay: (_: any, i: number) => delay * (i + 1),
      },
    },
  ];
};
